import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapCommercialOffers = () => <SiteMapOffersType offerType={OfferType.COMMERCIAL} />;
import React from "react";

import {OfferType} from "../../../offer/types/OfferType";
import {SiteMapOffersType} from "./SiteMapOffersType";

export const SiteMapCommercialOffers = () => <SiteMapOffersType offerType={OfferType.COMMERCIAL} />;
